import { ComponentType } from 'react'
import { Message, MessageSemantic } from '@komi-app/creator-ui'

import { useMaintenance } from 'hooks/maintenance'

export const MAINTENANCE_CRM_TEXT =
  'The Fan CRM is unavailable while Komi undergoes scheduled maintenance. Fan-facing pages are not affected.'

export const MaintenanceNotice = () => (
  <div style={{ padding: 24 }}>
    <Message semantic={MessageSemantic.ERROR} text={MAINTENANCE_CRM_TEXT} />
  </div>
)

/**
 * Renders a maintenance notice in place of a page while services take consumer
 * traffic only. Applied at the route so the section stays in the menu and
 * reachable — the page explains itself instead of failing on save — and no
 * code inside the section is touched.
 */
export function withMaintenanceNotice<P extends object>(
  Component: ComponentType<P>
): ComponentType<P> {
  const Wrapped = (props: P) => {
    const maintenance = useMaintenance()

    return maintenance ? <MaintenanceNotice /> : <Component {...props} />
  }

  Wrapped.displayName = `withMaintenanceNotice(${
    Component.displayName || Component.name || 'Component'
  })`

  return Wrapped
}

export default MaintenanceNotice
